import { INSERT, SELECT, UPDATE } from "@/utils/database_module";
import { Hangar } from "@/utils/types";

const landing = {
  getAll: async () => {},

  insert: async (item: any) => {
    return await INSERT("landing", item);
  },

  insertClient: async (item: any) => {
    return await INSERT("clients", item);
  },

  getAllClients: async () => {
    
    const affiliates = await SELECT('clients' , {order : "date DESC"} ) as {id : number, name : string, code : string, date : string}[]
    
    // clients of each affiliation
    const clients = await SELECT('landing' ,{order : "date DESC"} ) as {id : number ,firstName : string, lastName : string,  phone : string, serviceType : string , code : string}[]
   
    const result = affiliates.map(affiliate => {
      const affiliation = clients.filter(affiliation => affiliation.code == affiliate.code)
      return {...affiliate, affiliationNumber : affiliation.length}
    })
    return result
  },

  getAllAffiliations: async () => {
    const clients = await SELECT('landing' ,{order : "date DESC"}) as {id : number ,firstName : string, lastName : string,  phone : string, serviceType : string , code : string}[]
    const affiliates = await SELECT('clients' , {order : "date DESC"}) as {id : number, name : string, code : string, date : string}[]
    const result = clients.map(client => {
      const affiliation = affiliates.find(affiliation => affiliation.code == client.code)
      return {...client, affiliate : affiliation}
    })
    return result
  },
};

export default landing;
